import { render, staticRenderFns } from "./ResizeSplitPane.vue?vue&type=template&id=0b4d7286&scoped=true&"
import script from "./ResizeSplitPane.vue?vue&type=script&lang=js&"
export * from "./ResizeSplitPane.vue?vue&type=script&lang=js&"
import style0 from "./ResizeSplitPane.vue?vue&type=style&index=0&id=0b4d7286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d7286",
  null
  
)

export default component.exports